const guidelines = {
  music: [
    {
      name: "Classical Vocal Solo (Hindustani/Carnatic)",
      p: 1,
      a: 2,
      time: 15,
    },
    {
      name: "Classical Instrumental Solo (Percussion Tala Vadya)",
      p: 1,
      a: 2,
      time: 15,
    },
    {
      name: "Classical Instrumental Solo (Non-Percussion Swara Vadya)",
      p: 1,
      a: 2,
      time: 15,
    },
    {
      name: "Light Vocal Solo (Indian)",
      p: 1,
      a: 2,
      time: 7,
    },
    {
      name: "Western Vocal Solo",
      p: 1,
      a: 2,
      time: 7,
    },
    {
      name: "Group Song (Indian)",
      p: 6,
      a: 3,
      time: 15,
    },
    {
      name: "Group Song (Western)",
      p: 6,
      a: 3,
      time: 15,
    },
    {
      name: "Folk Orchestra",
      p: 12,
      a: 3,
      time: 15,
    },
  ],
  dance: [
    {
      name: "Folk / Tribal Dance",
      p: 10,
      a: 5,
      time: 15,
    },
    {
      name: "Classical Dance Solo",
      p: 1,
      a: 3,
      time: 12,
    },
  ],
  literary: [
    {
      name: "Quiz",
      p: 3,
      a: 0,
    },
    {
      name: "Debate",
      p: 2,
      a: 0,
      time: 10,
    },
    {
      name: "Elocution",
      p: 1,
      a: 0,
      time: 5,
    },
  ],
  theatre: [
    {
      name: "Skit",
      p: 6,
      a: 3,
      time: 10,
    },
    {
      name: "Mime",
      p: 6,
      a: 2,
      time: 6,
    },
    {
      name: "Mimicry",
      p: 1,
      a: 0,
      time: 5,
    },
    {
      name: "One Act Play",
      p: 9,
      a: 5,
      time: 30,
    },
  ],
  "fine-arts": [
    {
      name: "Collage",
      p: 1,
      a: 0,
      time: 150,
    },
    {
      name: "Rangoli",
      p: 1,
      a: 0,
      time: 150,
    },
    {
      name: "Cartooning",
      p: 1,
      a: 0,
      time: 150,
    },
    {
      name: "Installation",
      p: 4,
      a: 0,
      time: 150,
    },
    {
      name: "Poster Making",
      p: 1,
      a: 0,
      time: 150,
    },
    {
      name: "Clay Modelling",
      p: 1,
      a: 0,
      time: 150,
    },
    {
      name: "On Spot Painting",
      p: 1,
      a: 0,
      time: 150,
    },
    {
      name: "Spot Photography",
      p: 1,
      a: 0,
      time: 240,
    },
  ],
};

export default guidelines;
